import { Title } from "@radix-ui/react-alert-dialog";

import { cn } from "@/lib/utils";

type AlertTitleProps = {
  children: React.ReactNode;
  className?: string;
};

const AlertTitle = ({ children, className }: AlertTitleProps) => (
  <Title className={cn("text-left", className)}>{children}</Title>
);

export { AlertTitle };
